/**
 * D-074 Faz 2 (plan §4.0 "İşin tarihi", K28): "işin tarihine göre" kuralların tarih kaynağı. Belge tarihi (weld map satırı, NDT raporu,
 * PWHT grafiği, hidrotest grafiği) varsa her zaman o kullanılır. Belgede tarih yoksa: canlı yürütülen işte OASIS damgası (adım kapanışı,
 * fit-up release, paso girişi; Europe/Istanbul takvim günü), "Historical entry" işaretli işte hiç tarih yok: karşılaştırma yapılmaz,
 * uyarı çıkmaz. Geçmiş işin damgası giriş günüdür (10-22.10.2026); onunla karşılaştırılırsa her geçmiş test "tamirden önce" görünür.
 *
 * BU PR'DA HİÇBİR KURAL BU YARDIMCIYI ÇAĞIRMAZ. K28_TARIH_KURALLARI'ndaki altı kural (HT-07, WPQ-01, KAL-05, SARF-04, BY-06, GEN-14)
 * kapalıdır; her biri kendi motor PR'ında, bu yardımcıdan geçerek açılır. Hangi işlerin işaretleneceği listesi Bekir'den gelir;
 * uygulama hiçbir işi kendiliğinden işaretlemez.
 */
import { istanbulGunu } from "./ndt-yeterlilik.js";
/**
 * K28 (P:1472): "Historical entry" işaretli işte yalnız belge tarihiyle çalışacak tarih kuralları. Hepsi KAPALI (FAZ1_UYARI_KODLARI'nda
 * yok; bekçi testi is-tarihi.test.ts). NDT-02 burada yok: tarihi her zaman raporun test tarihidir (P:404), damgaya düşmez.
 */
export const K28_TARIH_KURALLARI = ["HT-07", "WPQ-01", "KAL-05", "SARF-04", "BY-06", "GEN-14"];
/** İş "Historical entry" işaretli mi (`tamir_kalemi.gecmis_is_ts` dolu). İş verilmezse canlı iş sayılır. */
export function gecmisIsMi(is) {
    const x = is?.gecmisIsTs;
    if (x instanceof Date)
        return !isNaN(x.getTime());
    if (typeof x === "string")
        return x.trim() !== "";
    return false;
}
/** Belge tarihi (gün başı UTC tutulan kolon ya da "YYYY-MM-DD") → "YYYY-MM-DD"; geçersiz ya da boş → null. Saat dilimi çevrilmez. */
export function belgeGunu(x) {
    if (x instanceof Date)
        return isNaN(x.getTime()) ? null : x.toISOString().slice(0, 10);
    if (typeof x !== "string" || !/^\d{4}-\d{2}-\d{2}/.test(x))
        return null;
    const gun = x.slice(0, 10);
    // Olmayan gün ("2026-02-30") Date'te sonraki aya kayar; geri okunan gün aynı değilse geçersizdir.
    const d = new Date(gun + "T00:00:00.000Z");
    return !isNaN(d.getTime()) && d.toISOString().slice(0, 10) === gun ? gun : null;
}
/** OASIS damgası (an) → Europe/Istanbul takvim günü "YYYY-MM-DD"; geçersiz ya da boş → null. */
export function damgaGunu(x) {
    if (x === null || x === undefined || x === "")
        return null;
    const d = new Date(x);
    return isNaN(d.getTime()) ? null : istanbulGunu(d);
}
/**
 * İşin bir olayının tarihi (§4.0): belge tarihi varsa o ("belge"); yoksa geçmiş işte null (karşılaştırma yapılmaz), canlı işte damga
 * ("damga"); damga da yoksa null. İş verilmezse canlı iş sayılır.
 */
export function isTarihi(is, belgeTarihi, damga) {
    const b = belgeGunu(belgeTarihi);
    if (b)
        return { gun: b, kaynak: "belge" };
    if (gecmisIsMi(is))
        return null;
    const d = damgaGunu(damga);
    return d ? { gun: d, kaynak: "damga" } : null;
}
/** Kaynağın tarihi: weld map'ten okunan kaynak tarihi (`weld.kaynak_tarihi`, M12) ya da isTarihi kuralıyla damga (paso girişi). */
export function kaynakGunu(is, kaynak, damga) {
    return isTarihi(is, kaynak.kaynakTarihi, damga);
}
//# sourceMappingURL=is-tarihi.js.map